require('../../modules/es6.object.assign');
module.exports = require('../../modules/$.core').Object.assign;


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/core-js/library/fn/object/assign.js
// module id = 1150
// module chunks = 0 1